module.exports = __webpack_public_path__ + "media/application/assets/images/company/stakeholders/arrow_down-7387f227ae65b2e2ca6b97df0a15f16c.svg";